<template>
  <div class="form-login-container">
    <form class="form-login" @submit.prevent="handleSubmit">
      <button class="close-login" @click="SET_LOGIN(false)" type="button">
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.3 12.179a.25.25 0 010-.354l9.263-9.262A1.501 1.501 0 0021.44.442L12.177 9.7a.25.25 0 01-.354 0L2.561.442A1.5 1.5 0 00.44 2.563L9.7 11.825a.252.252 0 01.054.273.25.25 0 01-.054.081L.44 21.442a1.501 1.501 0 002.121 2.121l9.262-9.263a.25.25 0 01.354 0l9.262 9.263a1.5 1.5 0 102.122-2.121l-9.26-9.263z" fill="currentColor"/>
        </svg>
      </button>
      <div class="form-header">
        <h3>Inloggen</h3>
        <p>Vul uw e-mailadres en wachtwoord in om in te loggen.</p>
      </div>
      <u-input
        id="user-email" 
        class="form-field" 
        v-model="email"
        label="E-mail"
        type="email"
        autocomplete="username"
      >
        <template v-if="submitAttempt && emailError" v-slot:error>
          <p>Dit veld is verplicht</p>
        </template>
      </u-input>
      <u-input
        id="current-password"
        class="form-field"
        v-model="password"
        label="Wachtwoord"
        type="password"
        autocomplete="current-password"
      >
        <template v-if="submitAttempt && passwordError" v-slot:error>
          <p>Dit veld is verplicht</p>
        </template>
      </u-input>
      <p class="login-error" v-if="submitAttempt && error">{{ error }}</p>
      <u-button :loading="loading">Inloggen</u-button>
    </form>
  </div>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'
  import UInput from './UInput'
  import UButton from './UButton'

  export default {
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    components: {
      UInput,
      UButton
    },
    data () {
      return {
        email: '',
        password: '',
        loading: false,
        submitAttempt: false,
        error: '',
      }
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapMutations } = createNamespacedHelpers(namespace)
      // methods
      this.$options.methods = {
        ...(this.$options.methods || {}),
        ...mapMutations(['SET_LOGIN']),
      }
    },
    computed: {
      emailError () {
        return !this.email
      },
      passwordError () {
        return !this.password
      }
    },
    methods: {
      async handleSubmit () {
        this.loading = true
        this.error = ''
        this.submitAttempt = true
        if (this.emailError || this.passwordError) {
          this.error = 'Vul alstublieft alle velden correct in.'
          this.loading = false
          return false
        }
        try {
          await this.$store.dispatch('auth/login', { email: this.email, password: this.password })
          this.loading = false
          this.SET_LOGIN(false)
        } catch (e) {
          this.loading = false
          if (e.response && e.response.data) {
            this.error = e.response.data.error
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .form-login-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: rgba(0,0,0,0.1);
    z-index: 10;

    @include screen(md) {
      align-items: center;
    }

  }

  .form-login {
    position: relative;
    background: white;
    padding: 3em;
    max-width: 480px;
    width: 100%;

    .login-error {
      color: var(--ec-red, red);
      padding-bottom: 1.5em;
    }

  }

  .form-header {
    h3 {
      font-size: 1.5em;
      line-height: 1.33;
      margin-bottom: .5em;

      @include screen(md) {
        font-size: 1.75em;
        line-height: 1.2;
      }

    }

    p {
      color: var(--ec-gray, lighten(black, 35));
      padding-bottom: 1.5em;
    }
  }

  .close-login {
    display: flex;
    position: absolute;
    top: 1.5em;
    right: 1.5em;
    background: transparent;
    border: 0;
    padding: .5em;
    outline: none;
    cursor: pointer;
    width: 2em;
    height: 2em;
  }

  .form-field {
    padding-bottom: 1.5em;
  }

</style>